module.exports = __webpack_public_path__ + "img/benefit_card_image_1.7738a2f0.png";